// extracted by mini-css-extract-plugin
export default {"row":"account_row__Ix4E5","accountContainer":"account_accountContainer__rSSiP","text":"account_text__xx7Yn"};